import { DropdownOptionsService } from '../../../../../core/services/dropdown-options.service';
import { Component, EventEmitter, Injector, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Dialog } from 'primeng/dialog';
import { LogisticsService } from 'src/app/features/transport-operation/services/logistics.service';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { deepCopy, isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import * as ValidationFuncs from 'src/app/core/utils/validation-functions';
import { HttpErrorResponse } from '@angular/common/http';
import { WarehousingSearchService } from '../../../services/warehousing-search.service';
import { Dropdown } from 'primeng/dropdown';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { FacilityService } from 'src/app/core/services/facility.service';
import { LaasOption } from 'src/app/core/models/laas-option';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { FacilityOptions } from 'src/app/core/models/options/facility-options';

@Component({
  selector: 'laas-assign-warehousing',
  templateUrl: './assign-warehousing.component.html',
  styleUrls: ['./assign-warehousing.component.scss']
})
export class AssignWarehousingComponent extends SessionBaseComponent implements OnInit{

  // For facility dropdown permission filtering
  readonly facilityPermissionCode: PermissionConstants = PermissionConstants.AssignWarehousing;

  readonly ExpressTermEditPermissionCode: PermissionConstants = PermissionConstants.EditWarehousingFormExpressTerm;

  @Input() whNo: any;
  @Output() visibleChange: EventEmitter<any>;
  @Output() assignClick: EventEmitter<any>;
  @ViewChild(Dialog) dialog!: Dialog;

  isVisible: boolean;
  submitted: boolean;
  isExpressTermEdit = false;

  assignWarehousingParams : any;
  assignForm: FormGroup;

  facilityOptions : any[] = [];
  bookingForwarderOptions : any[] = [];
  deliveryOptions : any[] = [];
  shipTermOptions: LaasOption[] = [];

  fromCountryOptions : any[] = [];
  fromCityOptions : any[] = [];
  fromAreaOptions : any[] = [];
  expressTermOptions: LaasOption[] = [];
  yesNoOption: any[] = [];
  vendorSuggests: string[] = [];
  vendorOptions : any[] = [];
  carTypeOptions: any[] = [];

  warehousingHeader: any;

  constructor(
    injector: Injector,
    private logisticsService: LogisticsService,
    private commonDataService: CommonDataService,
    private dropdownOptionService: DropdownOptionsService,
    private warehousingSearchService :  WarehousingSearchService,
    private facilityService : FacilityService,
    private fb: FormBuilder) {

      super(injector);
      this.isVisible = false;


      this.submitted = false;
      this.visibleChange = new EventEmitter<any>();
      this.assignClick = new EventEmitter<any>();


      this.assignWarehousingParams ={
        facility : "",
        shipper: "",
        deliveryType: "",
        shipTerm: "",
        fromCountry : "",
        fromCity: null,
        fromArea: null,
        expressTerm: null,
        vendorCustomer : null,
        totalCartonCnt : 0,
        whDt: null,
        isGenerateFee: 1,
        palletCnt: null,
        uom: null
      }

      this.assignForm = this.fb.group({
        facility : ["", Validators.required],
        shipper: ["", Validators.required],
        deliveryType: ["", Validators.required],
        shipTerm: ["", Validators.required],
        fromCountry : ["", Validators.required],
        fromCity: [null, Validators.required],
        fromArea: null,
        expressTerm: null,
        vendorCustomer : [null, Validators.required],
        totalCartonCnt : [0, Validators.required],
        whDt: null,
        isGenerateFee: 1,
        palletCnt: null,
        uom: null
      })
  }

  initOptions(): void {
    this.yesNoOption = [
      { label: 'N', value: 0 },
      { label: 'Y', value: 1 }
    ];

    this.dropdownOptionService.getFacilityOptions()
    .subscribe({
      next: (options: any[]) => {
        this.facilityOptions = options.map(x => ({ label : x.optionDesc, value : x.optionCode }));
      }
    });

    this.dropdownOptionService.getForwarderOptions()
    .subscribe({
      next: (result: any[]) => {
        this.bookingForwarderOptions = result;
      }
    });


    // 單據類型
    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'InboundDeliveryType')
    .subscribe({
      next: (options: any[]) => {
        this.deliveryOptions = options.map(x => ({ label: x.codeDesc, value: x.codeKey }));
      }
    });


    this.commonDataService.getCodeConverter(this.laasSetting.language, 'DropdownList', 'ShipTerm').subscribe({
      next: result => {
        this.shipTermOptions = [...result].map((x: any) => {
          return {
            label: `${x.codeKey}-${x.codeDesc}`,
            value: x.codeKey,
          };
        });
      }
    });



    this.facilityService.getFacilityLocation(this.laasSetting.facility)
      .subscribe({
      next: (result: any[]) => {

        console.log("result:",result[0]);

        this.assignWarehousingParams.fromCountry = result[0].countryName;
        this.assignWarehousingParams.fromCity = result[0].cityName;
        this.assignWarehousingParams.fromArea = result[0].regionName;

        this.dropdownOptionService.getCountryOptions()
            .subscribe({
            next: (options: any[]) => {
              this.fromCountryOptions = options.map(x => ({ label: x.countryName, value: x.countryCode }));
            }
        });

        this.dropdownOptionService.getAllCityOptions()
        .subscribe({
          next: (options: any[]) => {
            this.fromCityOptions = options.filter(x => x.country == this.assignWarehousingParams.fromCountry).map(x => ({ label: x.name, value: x.seqNo.toString() }));
          }
        });

        this.dropdownOptionService.getAllAreaOptionForHK()
        .subscribe({
          next: (options: any[]) => {
            this.fromAreaOptions = options.filter(x => x.citySeqNo == Number(this.assignWarehousingParams.fromCity) ).map(x => ({ label: x.rfqAreaName, value: x.rfqAreaCode }));
          }
        });

      }
    });

    this.dropdownOptionService.findFacilityOptionsByOptionType('ExpressTerm')
      .subscribe({
        next: (options: FacilityOptions[]) => {
          this.expressTermOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });

    //計算單位aka車型
    this.dropdownOptionService.getCarTypeOptions()
      .subscribe({
        next: (options: any[]) => {
          this.carTypeOptions = options.map(x => ({ label: x.optionDesc, value: x.optionCode }));
        }
      });
  }

  @Input() get visible(): any {
    return this.isVisible;
  }

  set visible(value: any) {
    this.isVisible = value;
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.initOptions();

    this.warehousingHeader = await this.warehousingSearchService.searchWarehousingByWhNo(this.whNo);
    this.assignWarehousingParams.vendorCustomer = this.warehousingHeader.vendorCustomer;
    this.dropdownOptionService.getVendorOptions(this.warehousingHeader.vendorCustomer).subscribe({
      next: (options: any[]) => {
      this.vendorOptions = options.map(x => ({ label: x.optionDesc , value: x.optionCode }));
      }
    });

    this.isExpressTermEdit = this.permissionCodes.includes(this.ExpressTermEditPermissionCode);
  }

  dialogVisibleChange(event: any): void {
    this.visibleChange.emit(event);
  }



  changeCityOptions(): void {

    this.assignWarehousingParams.fromCity = "";
    this.assignWarehousingParams.fromArea = "";

    this.dropdownOptionService.getAllCityOptions()
    .subscribe({
      next: (options: any[]) => {
        this.fromCityOptions = options.filter(x => x.country == this.assignWarehousingParams.fromCountry).map(x => ({ label: x.name, value: x.seqNo.toString() }));
      }
    });

    this.fromAreaOptions = [];
  }


  changeAreaOptions(): void {
    this.assignWarehousingParams.fromArea = "";
    this.dropdownOptionService.getAllAreaOptionForHK()
    .subscribe({
      next: (options: any[]) => {
        this.fromAreaOptions = options.filter(x => x.citySeqNo == Number(this.assignWarehousingParams.fromCity) ).map(x => ({ label: x.rfqAreaName, value: x.rfqAreaCode }));
      }
    });

  }


  getVendorOptions(event: any): void {
    const key: string = event.query;
    if(key != null && key.length > 1 ){
      this.dropdownOptionService.getVendorOptions(key).subscribe({
        next: (options: any[]) => {
          this.vendorSuggests = options.map(x => x.optionDesc);
          this.vendorOptions = options.map(x => ({ label: x.optionDesc , value: x.optionCode }));
        }
      });
    }
  }


  cancelBtnClick(event: any): void {
    this.dialog.close(event);
  }


  confirmBtnClick(event: any): void {

    this.assignWarehousingParams.whNo = this.whNo;

    // 供應商
    if (!isNullOrEmpty(this.assignWarehousingParams.vendorCustomer)) {
      let vendorTmp = this.assignWarehousingParams.vendorCustomer;
      let vendorTmpArray = this.vendorOptions.filter(x => {
        return x.label === vendorTmp;
      });

      if(vendorTmpArray.length > 0){
        let temp = vendorTmpArray[0].label;
        let label = temp.substring(temp.lastIndexOf('-') + 2, temp.length);
        this.assignWarehousingParams.vendorCustomerName = label;
        this.assignWarehousingParams.vendorCustomer = vendorTmpArray[0].value;
      }else{
        this.assignWarehousingParams.vendorCustomerName = this.assignWarehousingParams.vendorCustomer;
      }
    }

    if (this.assignForm.invalid) {
      this.toastService.warn(this.translateService.instant('ReceiptFormQuery.Alert.CheckRequired'));
      return;
    }

    this.confirmationService.confirm({
      message: this.translateService.instant('ReceiptFormQuery.Confirm.ConfirmAssignWarehousingForm'),
      header: this.translateService.instant('ReceiptFormQuery.Confirm.ConfirmAssign'),
      accept: () => {

        this.warehousingSearchService.assignWarehousing(this.assignWarehousingParams)
        .subscribe({
          next: result => {
            console.log("result:",result);
            this.dialog.close(event);
            this.toastService.info(this.translateService.instant('ReceiptFormQuery.Info.AssignSuccess') + ' WhNo:'+result[0]);
          },
          error: (err: any) => {
            this.toastErrorMessage(err.error);
          }
        });

      },
      reject: () => {
        this.confirmationService.close();
      }
    });

  }


  changeForwarder(){
    let facility = this.assignWarehousingParams.facility;

    this.dropdownOptionService.getForwarderOptions(facility)
    .subscribe({
      next: (result: any[]) => {
        this.bookingForwarderOptions = result;
      }
    });

  }

  changeValidation() {
    if (this.assignForm.value.deliveryType == 'LOCAL') {
      this.assignForm.controls.shipTerm.clearValidators();
      this.assignForm.controls.shipTerm.setValue(null);
    } else {
      this.assignForm.controls.shipTerm.setValidators(Validators.required);
    }

    this.assignForm.controls.shipTerm.updateValueAndValidity();
  }

  updateValidity(control: AbstractControl): boolean{
    return control.validator !== null;
  }

  dateOnChange(date: any, type: string) {
    switch (type) {
      case 'whDt':
        this.assignForm.controls.whDt.setValue(date.date);
        this.assignWarehousingParams.whDt = date.date;
        break;
    }
  }

  optionsDataOnChange(data: any, type: string): void {
    switch (type) {
      case 'facility':
        this.assignWarehousingParams.facility = data;
        this.changeForwarder();
        break;
    }
  }
}
